import React, { useMemo } from "react";
import { SectionLabelComponent } from "./SectionLabel/SectionLabel";
import { useLocation } from "react-router-dom";
import { StepPathType } from "../../../shared";
import EditPencil from "../../icons/EditPencil";
import { useCurrent } from "../../../hooks/useCurrent";
import useButtonPosition from "../../../hooks/useButtonPosition";
import { useShelvingStore } from "../../../store/useShelvingStore";
import shallow from "zustand/shallow";
import { useStoreSystem } from "../../../store";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

interface EditItemButtonsProps {
    camera: any;
    canvasSize: any;
}

export const EditItemButtons: React.FunctionComponent<EditItemButtonsProps> = ({ canvasSize, camera }): any => {
    const { getCurrentShelf } = useShelvingStore(
        (state) => ({
            getCurrentShelf: state.getCurrentShelving,
        }),
        shallow
    );
    const currentShelf = getCurrentShelf();
    const calcPosition = useButtonPosition("custom");
    useStoreSystem((state) => state.labels, shallow); //FIXME при зуме камеры происходит обовление labels, за счет этого происходит рендер этого компонента, соответственно пересчитывается положение кнопок. Выглядит как костыль. Сами значения labels нигде не используются

    const { currentEditItem, currentSectionId } = useCurrent();
    const currentSection = useMemo(() => {
        return currentShelf.sections.find((section) => section.id === currentSectionId);
    }, [currentShelf.sections, currentSectionId]);

    const editItem = useMemo(() => {
        return currentSection?.items.find((item) => item.id === currentEditItem.id);
    }, [currentSection, currentEditItem]);

    const location = useLocation();
    const currentMenu = useMemo(() => location.pathname.split("/")[1], [location]) as StepPathType;

    if (editItem && camera && canvasSize && currentSection && !currentEditItem.isMove && currentMenu === "items") {
        return (
            <>
                <SectionLabelComponent
                    id={editItem?.id}
                    value={<EditPencil isChecked={true} />}
                    key={`${editItem?.id}`}
                    pos={calcPosition(currentSection, editItem.position[1] - 0.05)}
                    camera={camera}
                    canvasSize={canvasSize}
                    type={"item"}
                />
                <SectionLabelComponent
                    id={editItem?.id}
                    value={<AddRoundedIcon />}
                    key={`-${editItem?.id}`}
                    pos={calcPosition(currentSection, editItem.position[1] - 0.05)}
                    camera={camera}
                    canvasSize={canvasSize}
                    type={"addParts"}
                />
            </>
        );
    }
}
